import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface productInitialSliceI {
  totalPages: number;
  totalRecords: number;
}

const initialState: productInitialSliceI = {
  totalPages: 0,
  totalRecords: 0
};

export const productSlice = createSlice({
  name: 'userSlice',
  initialState,
  reducers: {
    setProductTotalPages: (
      state: productInitialSliceI,
      actions: PayloadAction<productInitialSliceI>
    ) => {
      state.totalPages = actions.payload.totalPages;
      state.totalRecords = actions.payload.totalRecords;
    }
  }
});
